export enum RoutePath {
  Home = '/',
  Login = '/login',
  Users = '/users',
  Assets = '/assets',
  Customers = '/customers',
  Transactions = '/transactions',
}
